<template>
<div>
  <v-row>
    <v-col lg="3" sm="6" class="pl-2 mb-4" v-for="(item, index) in allCaseTracking" :key="index">
    <update-case-tracking :label_en="item.label_en" :value="item.value" :id="item.id"></update-case-tracking>
    </v-col>
  </v-row>
  <v-row no-gutters class="mx-0">
    <!-- News Section -->
    <v-col cols="12" sm="12" md="6" lg="6" class="pl-2 mb-4">
      <v-card max-width="700" elevation="4">
        <v-app-bar color="white" elevation="4" max-width="700">
         <span class="font-weight-black">{{ news }}</span></v-app-bar
        >
        <div class="row justify-content-center">
          <div class="col-12">
            <latest-news />
          </div>
        </div>
      </v-card>
    </v-col>
    <v-col cols="12" sm="12" md="6" lg="6" class="pl-2 mb-4">
      <v-card max-width="700">
        <v-app-bar color="white" max-width="700"><span class="font-weight-black"> {{ announcement }} </span></v-app-bar>
        <div class="row justify-content-center">
          <div class="col-12">
            <latest-announcement />
          </div>
        </div>
      </v-card>
    </v-col>
    <!-- Volunteers -->
    <v-col cols="12" sm="12" md="6" lg="6" class="pl-2 mb-4">
      <v-card max-width="700">
        <v-app-bar  color="white" max-width="700"><span class="font-weight-black">
          {{ volenteers }}</span></v-app-bar
        >
        <div class="row justify-content-md-start ml-4">
          <div>
            <latest-registered-volunteers />
          </div>
        </div>
      </v-card>
    </v-col>

    <!-- Users -->
    <v-col cols="12" sm="12" md="6" lg="6" class="pl-2">
      <v-card max-width="700">
        <v-app-bar color="white" max-width="700">
          <span class="font-weight-black">
          {{ users }}</span></v-app-bar
        >
        <div class="row justify-content-md-start ml-4">
          <div>
            <registered-users />
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
  </div>
</template>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
<script>
import LatestNews from "../components/LatestNews copy";
import LatestAnnouncement from "../components/LatestAnnouncements copy";
import LatestRegisteredVolunteers from "../components/LatestRegisteredVolunteers copy";
import RegisteredUsers from "../components/RegisteredUsers copy";
import SideBar from "../components/SideBar";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import UpdateCaseTracking from '../components/updateCaseTracking copy.vue';

export default {
  name: "Dashboard",
  async created() {
    await this.fetchAllCaseTracking2();
  },

  props: {
    msg: String,
    button: String,
  },
  computed: {
  ...mapFields("case_tracking", ["allCaseTracking"]),
  },
  components: {
    SideBar,
    LatestNews,
    LatestAnnouncement,
    LatestRegisteredVolunteers,
    RegisteredUsers,
    UpdateCaseTracking
  },
  methods: {
    ...mapActions("case_tracking", ["fetchAllCaseTracking2"]),
  },
  data: () => ({
    announcement: "Latest Announcements",
    news: "Latest News",
    volenteers: "Recently Registered Volunteers | Chart",
    users: "Recently Registered Volunteers",
  }),
};
</script>


